import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const SERVICES = [
  {
    id: "01",
    title: "Content Strategy",
    desc: "We plan what to post, when, and why — built around your business goals.",
  },
  {
    id: "02",
    title: "Content Scripting",
    desc: "Hooks, structure and scripts that keep people watching to the end.",
  },
  {
    id: "03",
    title: "Editing",
    desc: "Edits that are clean, minimal and easily consumable — so people don’t scroll away.",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="border-t border-[#0D0D0D]/10 px-6 py-24 sm:px-10 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#4A4944] sm:text-xs"
        >
          (02) — Services
        </motion.p>
        <motion.h2
          data-testid="what-we-do-heading"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="mt-6 font-helvetica text-5xl font-bold tracking-tight text-[#0D0D0D] sm:text-6xl lg:text-7xl"
        >
          WHAT WE DO
        </motion.h2>

        <div className="mt-10 grid gap-10 border-t border-[#0D0D0D]/10 pt-10 sm:mt-14 sm:grid-cols-3 sm:gap-8 sm:pt-14">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              data-testid={`what-we-do-item-${s.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            >
              <span className="font-mono-label text-[10px] tracking-[0.2em] text-[#8C8B85]">
                ({s.id})
              </span>
              <h3 className="mt-4 font-helvetica text-2xl font-bold tracking-tight text-[#0D0D0D] sm:text-3xl">
                {s.title}
              </h3>
              <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#4A4944]">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
